/**
 * Centralized SEO metadata for every SPA route.
 * Used by PageMeta component with react-helmet-async.
 */
export const SEO = {
  '/tools': {
    title: 'All PDF Tools — Free Online | Scrivar',
    description: 'Browse all PDF tools: merge, compress, convert, sign, edit, split, protect, OCR, and more. Free in your browser.',
    canonical: 'https://scrivar.com/tools',
  },
  '/merge': {
    title: 'Merge PDF Files Online — Free | Scrivar',
    description: 'Combine multiple PDF files into one document. Drag and drop to reorder pages. Free online PDF merger.',
    canonical: 'https://scrivar.com/merge',
  },
  '/compress': {
    title: 'Compress PDF Online — Reduce File Size | Scrivar',
    description: 'Reduce PDF file size with three compression levels. Free online PDF compressor — no signup required.',
    canonical: 'https://scrivar.com/compress',
  },
  '/convert': {
    title: 'Convert PDF Online — Images, Word, Excel | Scrivar',
    description: 'Convert files to and from PDF. Support for images, Word, Excel, and PowerPoint. Free online converter.',
    canonical: 'https://scrivar.com/convert',
  },
  '/sign': {
    title: 'Sign PDF Online — Free | Scrivar',
    description: 'Add your signature to any PDF. Draw, type, or upload your signature. Free online PDF signing tool.',
    canonical: 'https://scrivar.com/sign',
  },
  '/split': {
    title: 'Split PDF Online — Extract Pages | Scrivar',
    description: 'Split PDFs into separate files or extract specific pages. Free online PDF splitter.',
    canonical: 'https://scrivar.com/split',
  },
  '/protect': {
    title: 'Protect & Unlock PDF Online | Scrivar',
    description: 'Password-protect your PDFs or remove existing passwords. Free online PDF security tool.',
    canonical: 'https://scrivar.com/protect',
  },
  '/ocr': {
    title: 'OCR PDF Online — Text Recognition | Scrivar',
    description: 'Convert scanned PDFs to searchable text with OCR. Free online optical character recognition.',
    canonical: 'https://scrivar.com/ocr',
  },
  '/viewer': {
    title: 'View PDF Online — Free PDF Reader | Scrivar',
    description: 'Open and read PDFs in your browser. Thumbnails, zoom, annotations. Free online PDF viewer.',
    canonical: 'https://scrivar.com/viewer',
  },
  '/invoice': {
    title: 'Create Invoices Online — PDF Invoice Builder | Scrivar',
    description: 'Build professional invoices with live preview. Auto-calculated totals, custom branding. Export to PDF.',
    canonical: 'https://scrivar.com/invoice',
  },
  '/batch': {
    title: 'Batch Process PDFs Online | Scrivar',
    description: 'Process multiple PDF files at once. Merge, compress, convert, or protect in bulk. Free batch processing.',
    canonical: 'https://scrivar.com/batch',
  },
  '/watermark': {
    title: 'Add Watermark to PDF Online | Scrivar',
    description: 'Add text or image watermarks to your PDFs. Configurable position, opacity, and rotation.',
    canonical: 'https://scrivar.com/watermark',
  },
  '/page-numbers': {
    title: 'Add Page Numbers to PDF Online | Scrivar',
    description: 'Number every page of your PDF. Choose position, format, font, and starting number.',
    canonical: 'https://scrivar.com/page-numbers',
  },
  '/flatten': {
    title: 'Flatten PDF Online — Remove Form Fields | Scrivar',
    description: 'Flatten PDF forms and annotations into static content. Preserve appearance, remove editability.',
    canonical: 'https://scrivar.com/flatten',
  },
  '/crop': {
    title: 'Crop PDF Online — Trim Margins | Scrivar',
    description: 'Crop PDF pages visually. Auto-detect margins or use paper size presets. Free online PDF cropper.',
    canonical: 'https://scrivar.com/crop',
  },
  '/redact': {
    title: 'Redact PDF Online — Remove Sensitive Content | Scrivar',
    description: 'Permanently remove sensitive information from PDFs. Draw redaction boxes to destroy content.',
    canonical: 'https://scrivar.com/redact',
  },
  '/delete': {
    title: 'Delete PDF Pages Online | Scrivar',
    description: 'Remove unwanted pages from your PDF. Select and delete pages visually. Free online tool.',
    canonical: 'https://scrivar.com/delete',
  },
  '/rotate': {
    title: 'Rotate PDF Pages Online | Scrivar',
    description: 'Rotate individual pages or all pages in your PDF. 90, 180, 270 degree rotation. Free online tool.',
    canonical: 'https://scrivar.com/rotate',
  },
  '/activate': {
    title: 'Activate Scrivar — Enter Registration Code',
    description: 'Enter your Scrivar registration code to unlock full access to all PDF tools.',
    canonical: 'https://scrivar.com/activate',
  },
  '/login': {
    title: 'Sign In — Scrivar PDF Suite',
    description: 'Sign in to your Scrivar account to access your PDF tools and manage your license.',
    canonical: 'https://scrivar.com/login',
    robots: 'noindex, nofollow',
  },
  '/register': {
    title: 'Create an Account — Scrivar PDF Suite',
    description: 'Create a free Scrivar account to save signatures, sync PDFs to the cloud, and manage your subscription.',
    canonical: 'https://scrivar.com/register',
    robots: 'noindex, nofollow',
  },
  '/account': {
    title: 'My Account — Scrivar',
    description: 'Manage your Scrivar account, license, and active sessions.',
    canonical: 'https://scrivar.com/account',
    robots: 'noindex, nofollow',
  },
  '/account/billing': {
    title: 'Billing — Scrivar',
    description: 'Manage your Scrivar subscription, payment method, and invoices.',
    canonical: 'https://scrivar.com/account/billing',
    robots: 'noindex, nofollow',
  },
  '/account/esign-settings': {
    title: 'eSign Settings — Scrivar',
    description: 'Configure reminders, expiration rules, and sender defaults for Scrivar eSign.',
    canonical: 'https://scrivar.com/account/esign-settings',
    robots: 'noindex, nofollow',
  },
  '/cloud': {
    title: 'Cloud Storage — Scrivar',
    description: 'View and manage your Scrivar cloud documents. Sync PDFs across devices.',
    canonical: 'https://scrivar.com/cloud',
    robots: 'noindex, nofollow',
  },
  '/esign': {
    title: 'eSign Dashboard — Scrivar',
    description: 'Track outgoing envelopes, reminders, and signing status.',
    canonical: 'https://scrivar.com/esign',
    robots: 'noindex, nofollow',
  },
  '/welcome': {
    title: 'Welcome to Scrivar',
    description: 'Get started with Scrivar PDF Suite.',
    canonical: 'https://scrivar.com/welcome',
    robots: 'noindex, nofollow',
  },
};
